import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import DraftItemAssetsListService from '../services/DraftItemAssetsListService';
import DraftItemAssetsList from './DraftItemAssetsList';

class DraftItemAssetsListContainer extends React.Component {
  static propTypes = {
    item: PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.shape({
        key: PropTypes.string.isRequired,
        requiredAssetsTypes: PropTypes.arrayOf(PropTypes.string),
      }).isRequired,
    }).isRequired,
  };

  draftItemAssetsListService = new DraftItemAssetsListService();
  componentDidMount() {
    this.draftItemAssetsListService.init(this.props.item);
  }

  render() {
    return (
      <DraftItemAssetsList
        item={this.props.item}
        assets={toJS(this.draftItemAssetsListService.assets)}
        onItemAssetUploadPercentageChange={this.draftItemAssetsListService.handleItemAssetUploadPercentageChange}
      />
    );
  }
}

export default observer(DraftItemAssetsListContainer);
